module.exports = __webpack_public_path__ + "media/images/categories/carousel/news-eb16a11f4da819f1550a95148e9ed6b3.jpg";